import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {SpotifyTagsService} from "../services/spotify-tags-service";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public router: Router, private http: HttpClient, private service: SpotifyTagsService) {
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.service.isAuthenticated().pipe(
            map(res => {
                if (res.authenticated === false) {
                    this.router.navigateByUrl('/signup');
                    return false;
                } else {
                    return true;
                }
            }),
            catchError(err => {
                this.router.navigateByUrl('/signup');
                return of(false);
            })
        );
    }
}
